import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from "react";
import { ImFolderUpload } from "react-icons/im";
import { MdDeleteForever } from "react-icons/md";
import useAttachments from "@/features/attachments/hooks/useAttachments";
const FileUploadSection = ({ onFilesChange, addLabel, filesLabel, initialFiles = [], }) => {
    const fileInputRef = useRef(null);
    const [uploading, setUploading] = useState(false);
    const [attachments, setAttachments] = useState(initialFiles);
    const { handleAddAttachment, handleAddMultipleAttachments, handleDeleteAttachment } = useAttachments();
    const triggerFileInput = () => {
        fileInputRef.current?.click();
    };
    const handleFileChange = async (e) => {
        if (!e.target.files)
            return;
        const selectedFiles = Array.from(e.target.files);
        setUploading(true);
        try {
            let uploaded = [];
            if (selectedFiles.length === 1) {
                const formData = new FormData();
                formData.append("attachment", selectedFiles[0]);
                const addedAttachment = await handleAddAttachment(formData);
                uploaded = [addedAttachment];
            }
            else {
                const formData = new FormData();
                selectedFiles.forEach((file) => formData.append("attachments", file));
                uploaded = await handleAddMultipleAttachments(formData);
            }
            if (uploaded) {
                const updated = [...attachments, ...uploaded].filter(Boolean);
                setAttachments(updated);
                onFilesChange(updated);
            }
        }
        catch (err) {
            console.error("Échec de l’upload :", err);
        }
        finally {
            setUploading(false);
        }
    };
    const handleRemoveFile = async (index) => {
        await handleDeleteAttachment(attachments[index].id);
        const updated = attachments.filter((_, i) => i !== index);
        setAttachments(updated);
        onFilesChange(updated);
    };
    return (_jsxs("div", { children: [_jsx("button", { type: "button", onClick: triggerFileInput, className: "bg-blue-500 text-white px-4 py-2 rounded disabled:opacity-50", title: "S\u00E9lectionner un ou plusieurs fichiers", disabled: uploading, children: _jsxs("div", { className: "flex items-center space-x-2", children: [_jsx(ImFolderUpload, { className: "w-5 h-5" }), _jsx("span", { children: addLabel ?? "Sélectionner...fichiers" })] }) }), _jsx("input", { type: "file", multiple: true, ref: fileInputRef, onChange: handleFileChange, className: "hidden" }), attachments.length > 0 && (_jsxs("div", { className: "mt-4", children: [_jsxs("h3", { className: "font-semibold", children: [filesLabel ?? "Fichiers ajoutés", ":"] }), _jsx("ul", { children: attachments.map((file, index) => (_jsxs("li", { className: "flex items-center justify-between", children: [_jsx("span", { title: file.file_name, children: file.file_name.length > 20
                                        ? `${file.file_name.slice(0, 20)}...`
                                        : file.file_name }), _jsx("button", { type: "button", onClick: () => handleRemoveFile(index), className: "text-red-500", children: _jsx(MdDeleteForever, {}) })] }, file.id ?? index))) })] }))] }));
};
export default FileUploadSection;
